<template>
  <div class="general" :class="darkMode ? 'dark' : ''">
    <div class="inputgroup">
      <UISelect
        :title="$t('Age Limit')"
        v-model="localStation.ageLimit"
        class="agerestrictionselect"
        :instructions="$t('This will only show the customer content that has been rated appropriate for the selected age.')"
      >
        <option v-for="age in ages" :value="age" :key="age">
          <span v-if="age === 0">{{ $t('Any age') }}</span>
          <span v-else>{{ age }}</span>
        </option>
      </UISelect>
    </div>
    <div class="inputgroup">
      <UISelect
        :title="$t('Language')"
        name="locale"
        v-model="localStation.locale"
        class="agerestrictionselect"
      >
        <option v-for="locale in locales" :key="locale.key" :value="locale.key">{{ locale.text }}</option>
      </UISelect>
    </div>
    <div class="inputgroup maintenancemode">
      <UISwitch
        :title="$t('Maintenance Mode')"
        :instructions="$t('When a station is in Maintenance Mode, your customers can not make an online reservation. If you want your station to still be available for online reservation except during your scheduled maintenance time slot, you can create a new reservation through the monitor and call it Maintenance.')"
        v-model="localStation.maintenanceModeEnabled"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UISelect from '@/core/shared/components/ui/UISelect';
import UISwitch from '@/core/shared/components/ui/UISwitch';

@Component({
  components: {
    UISwitch,
    UISelect,
  },
  props: {
    station: {
      type: Object,
      required: true,
    },
    locales: {
      type: Array,
      required: true,
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
  },
})
export default class StationSettingsGeneral extends Vue {
  get localStation () {
    return new Proxy(this.station, {
      set: (object, property, value) => {
        this.$emit('edit:station', property, value);
        return true;
      },
    });
  }

  get ages () {
    return [0, ...this.station.ages];
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.general {
  display: grid;
  grid-gap: var(--spacingSm);

  @media (--phone) {
    grid-template-columns: repeat(2, 1fr);;
    grid-gap: var(--spacingMd);
  }

  @media (--tablet) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: var(--spacingMd);
  }

  @media (--desktopXL) {
    grid-template-columns: repeat(3, 1fr);
  }

  & .inputgroup {
    @media (--desktopXL) {
      grid-column: span 1;
    }

    @media (--phone) {
      grid-column: span 2;
    }

    @media (--tablet) {
      grid-column: span 1;
    }
  }

  & .maintenancemode {
    grid-column: span 2;
  }
}

.agerestrictionselect {
  color: var(--darkModeColorText) !important;
}
</style>
